import {
    TWO_FA_REQUESTING,
    TWO_FA_POSTING,
  } from './constants'
  
// In order to perform an action of type TWO_FA_REQUESTING
// we need an email and password
export const twoFASettingRequest = function twoFASettingRequest () {
  return {
    type: TWO_FA_REQUESTING
  }
}

export const twoFASettingPosting = function twoFASettingPosting (formData) {
  return {
    type: TWO_FA_POSTING,
    payload: formData
  }
}


// WEBPACK FOOTER //
// ./src/views/Pages/TwoFASetting/actions.js